// OrderCycleTimeline.js - visual timeline for a client Order's own status
// cycle (reçu -> prêt -> livré), matching ProductionCycleTimeline's design
// language (same node/connector styling) but with Order's own steps, not
// production's - the two are separate concepts, never conflated.
import React from "react";
import "./OrderCycleTimeline.css";

const STATUS_ORDER = ["reçu", "prêt", "livré"];
const STATUS_LABELS = {
  reçu: "Reçu",
  prêt: "Prêt",
  livré: "Livré",
};

const CheckIcon = ({ size = 16, color = "#fff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

const XIcon = ({ size = 16, color = "#dc2626" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

// Full-card variant, for the order details view.
export const OrderCycleTimelineCard = ({ status }) => {
  if (status === "annulé") {
    return (
      <div className="oct-card">
        <div className="oct-cancelled">
          <div className="oct-cancelled-icon"><XIcon /></div>
          <div>
            <div className="oct-cancelled-title">Commande annulée</div>
            <div className="oct-cancelled-sub">Le cycle de traitement a été interrompu.</div>
          </div>
        </div>
      </div>
    );
  }

  const currentIndex = STATUS_ORDER.indexOf(status);

  return (
    <div className="oct-card">
      <div className="oct-stepper">
        {STATUS_ORDER.map((s, i) => {
          const done = currentIndex >= 0 && i < currentIndex;
          const current = i === currentIndex;
          const upcoming = currentIndex === -1 || i > currentIndex;
          return (
            <div className="oct-step" key={s}>
              <div className={`oct-node-wrap${current ? " oct-node-wrap--pulse" : ""}`}>
                <div className={`oct-node${done ? " oct-node--done" : ""}${current ? " oct-node--current" : ""}${upcoming ? " oct-node--upcoming" : ""}`}>
                  {done && <CheckIcon size={16} />}
                  {current && <span className="oct-node-dot" />}
                  {upcoming && <span className="oct-node-index">{i + 1}</span>}
                </div>
              </div>
              <div className={`oct-step-label${current ? " oct-step-label--current" : ""}${done ? " oct-step-label--done" : ""}`}>
                {STATUS_LABELS[s]}
              </div>
              {i < STATUS_ORDER.length - 1 && (
                <div className={`oct-connector${done ? " oct-connector--done" : ""}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

// Compact variant, for table rows.
export const OrderCycleTimelineCompact = ({ status }) => {
  if (status === "annulé") {
    return (
      <div className="oct-compact-cancelled">
        <XIcon size={12} />
        <span>Annulée</span>
      </div>
    );
  }

  const currentIndex = STATUS_ORDER.indexOf(status);
  const doneCount = Math.max(0, currentIndex);
  const isTerminal = currentIndex === STATUS_ORDER.length - 1;

  return (
    <div className="oct-compact">
      <div className="oct-compact-segments">
        {STATUS_ORDER.map((s, i) => (
          <div key={s} className={`oct-compact-segment${i < doneCount || (i === currentIndex && isTerminal) ? " oct-compact-segment--done" : ""}`} />
        ))}
      </div>
      <div className="oct-compact-label-row">
        {isTerminal && <CheckIcon size={12} color="#16a34a" />}
        <span className={`oct-compact-label${isTerminal ? " oct-compact-label--done" : ""}`}>{STATUS_LABELS[status] || status}</span>
      </div>
    </div>
  );
};
